import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './components/homepage/Homepage';
import WrappedSlideshow from './components/slideshow/Slideshow';
import MakeAccountPublic from './components/makeAccountPublicPage/MakeAccountPublic';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import TermsOfService from './components/terms/TermsOfService'

function App() {
  return (
    <Routes>
      <Route index element={<Homepage />} />
      <Route path="/make-account-public" element={<MakeAccountPublic />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/:userId" element={<WrappedSlideshow />} />
    </Routes>
  );
}

function WrappedApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<WrappedApp />);